import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export const DEFAULT_SORT_MODEL = [{ colId: 'submissionDate', sort: 'asc' }];

export const otherCriticalColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'numberOfInReviewTasks',
    headerName: 'In Review Tasks',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'numberOfPendingOrMinTasks',
    headerName: 'Pending/MIN Tasks',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'primaryCsc',
    headerName: 'Primary CSC',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'loanUnderwriter',
    headerName: 'Underwriter',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'primaryRelationshipManager',
    headerName: 'Primary Relationship Manager',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'subStatus',
    headerName: 'Sub Status',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'appraisalReceivedDate',
    headerName: 'Appraisal Received Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'comment',
    headerName: 'Comment',
    minWidth: 220,
    ...filterProps(),
  },
  {
    field: 'loanBlockReason',
    headerName: 'Loan Block Reason',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'loanBlockReasonUpdatedDate',
    headerName: 'Loan Block Reason Updated',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'isOnHold',
    headerName: 'On Hold',
    minWidth: 110,
    ...filterProps(),
  },
];
